import { Injectable } from '@angular/core';
import { AuthService } from './modules/auth';
import { io } from 'socket.io-client';
export const Token = 'token';
@Injectable()
export class AppConstant {
    public static readonly MAX_FILE_SIZE = 10;
    private baseUrl: string;
    private whatsAppWebUrl: string;
    socket: any;
    token: string;

    constructor(private authService: AuthService) {
        if (window.location.href.indexOf('localhost') > 0) {
            this.baseUrl = 'http://localhost:10000';
            this.whatsAppWebUrl = 'https://api.whatsapp-web.eduwity.com';
        } else if (window.location.href.indexOf('app.jvmgrr.org') > 0) {
            this.baseUrl = 'https://api.app.jvmgrr.org';
        }
        else if (window.location.href.indexOf('jvmgrr.eduwity.com') > 0) {
            this.baseUrl = 'https://api.jvmgrr.eduwity.com';
            this.whatsAppWebUrl = 'https://api.whatsapp-web.eduwity.com';
        }
        else {
            this.baseUrl = 'http://localhost:10000';
        }

        this.token = this.authService.getTokenFromSession();
        // this.socket = io(this.baseUrl, { transports: ['websocket'], upgrade: false });
        if (this.token) {
            this.connectSocketHub();
        }
    }
    getUrl(): string {
        return this.baseUrl;
    }
    getWhatsAppURL(): string {
        return this.whatsAppWebUrl;
    }
    connectSocketHub() {
        this.token = this.authService.getTokenFromSession();
        this.socket = io(this.baseUrl, { transports: ['websocket'], upgrade: false });
        this.socket.emit('login', this.token);
    }
    getSocketInstance() {
        return this.socket;
    }
}
